import { useMemo } from "react";
import useGetPathPickFilterInfo from "@/features/pathpick/features/search-products/hooks/query/useGetPathPickFilterInfo";
import { toPathPickBrandOptions } from "@/features/pathpick/utils";

// "브랜드 필터에 걸 수 있는 브랜드 = filter-info 브랜드"라는 정의를 두는 유일한 곳.
// 즐겨찾기 브랜드처럼 다른 소스에서 온 브랜드 id는 이 집합에 없을 수 있는데,
// 그대로 brandId__in에 실으면 셀렉터 옵션에 없어 해제할 수 없고 칩에는 id가 그대로 노출된다.
// filter-info는 필터 패널/즐겨찾기 관리 모달이 이미 쓰는 같은 쿼리라 추가 요청이 없다.
const usePathPickFilterableBrandIds = () => {
  const { pathPickFilterInfo } = useGetPathPickFilterInfo();

  return useMemo(
    () =>
      new Set(
        toPathPickBrandOptions(pathPickFilterInfo?.brands).map(
          (brand) => brand.id
        )
      ),
    [pathPickFilterInfo]
  );
};

export default usePathPickFilterableBrandIds;
